import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";

// Register all AG Grid modules (Community + Enterprise)
ModuleRegistry.registerModules([AllCommunityModule, AllEnterpriseModule]);

// Set license key from Rails credentials (called from Main layout)
export function setAgGridLicenseKey(key: string | undefined) {
  if (key) {
    LicenseManager.setLicenseKey(key);
  }
}
